import { UserRound } from "lucide-react";
import { ROLE_LABELS, fileUrl } from "@/lib/activity";

export const PersonChip = ({ person, label, size = "md" }) => {
  const dim = size === "sm" ? "h-9 w-9" : "h-14 w-14";
  return (
    <div className="flex items-center gap-3" data-testid={`person-${label?.toLowerCase?.() || "x"}`}>
      {person?.photo_path ? (
        <img src={fileUrl(person.photo_path)} alt={person.name} className={`${dim} rounded-2xl object-cover border border-emerald-900/10`} />
      ) : (
        <div className={`${dim} rounded-2xl bg-emerald-50 text-emerald-800 flex items-center justify-center`}><UserRound size={size === "sm" ? 16 : 22} /></div>
      )}
      <div className="min-w-0">
        {label && <p className="text-[11px] uppercase tracking-widest text-emerald-700 font-semibold">{label}</p>}
        <p className="font-semibold text-emerald-950 leading-snug">{person?.name || "Belum ditentukan"}</p>
        {person?.expertise && size !== "sm" && <p className="text-xs text-slate-500">{person.expertise}</p>}
      </div>
    </div>
  );
};

export const PeopleList = ({ activity }) => {
  const entries = Object.entries(activity.people || {});
  if (entries.length === 0 && !activity.pic) return null;
  return (
    <div className="rounded-3xl bg-white border border-emerald-900/10 p-6" data-testid="activity-people">
      <h3 className="font-semibold text-emerald-950">Pemateri & Petugas</h3>
      <div className="mt-4 grid sm:grid-cols-2 gap-4">
        {entries.map(([role, p]) => <PersonChip key={role} person={p} label={ROLE_LABELS[role] || role} />)}
        {activity.pic && (
          <div className="flex items-center gap-3">
            <div className="h-14 w-14 rounded-2xl bg-[#f6ebd0] text-[#8a6d14] flex items-center justify-center"><UserRound size={22} /></div>
            <div><p className="text-[11px] uppercase tracking-widest text-emerald-700 font-semibold">Penanggung Jawab</p><p className="font-semibold text-emerald-950">{activity.pic}</p></div>
          </div>
        )}
      </div>
    </div>
  );
};
